/* eslint-disable camelcase */
import store from '../../store'
import {
  BUFFER_QUALITY,
  BUFFER_QUALITY_VALUES,
  BUFFER_WIDTH,
  BUFFER_WIDTH_VALUES,
  COMFORT_ZONE_WIDTH,
  COMFORT_ZONE_WIDTH_VALUES,
  CROSSING_IMPROVEMENTS,
  CROSSING_IMPROVEMENTS_VALUES,
  LIGHTING,
  LIGHTING_VALUES,
  PEDESTRIAN_FACILITY_TYPE,
  PEDESTRIAN_FACILITY_TYPE_VALUES,
  SIDEWALK_ACCESSIBILITY,
  USABLE_SIDEWALK_WIDTH,
  USABLE_SIDEWALK_WIDTH_VALUES
} from '../constants/pedestrian'
import { setPedestrianInputs } from '../slices/criteriaSelection/pedestrian'
import { removeTransitStopAmenitiesInput } from '../slices/criteriaSelection/transit'
import { getFirstAndLastSidewalksAreAttached } from './getFirstAndLastSidewalksAreAttached.utils'
import { setPedestrianStreetmixInput } from './pedestrianStreetmixInput.utils'

export function setPedestrianSegmentInput() {
  const { pedestrian, street, modalTiers } = store.getState()
  const { Pedestrian: PTier } = modalTiers
  const { pedestrian_facility_type } = pedestrian
  const { segments } = street

  // If Pedetrian Tier is 0 or NA , do not change inputs
  if (PTier === 0) {
    return
  }
  for (const key of Object.keys(pedestrian)) {
    switch (key) {
      case PEDESTRIAN_FACILITY_TYPE:
        // Check if there is a sidewalk
        if (segments.some((segment) => segment?.type === 'sidewalk') === true) {
          // THis is the case when there is a sidewalk, check if its attached or detached
          const sidewalkArr = segments.filter(
            (segment) => segment?.type === 'sidewalk'
          )
          const sidewalkIndexArr = sidewalkArr.map((sidewalk) =>
            segments.findIndex((segment) => segment?.id === sidewalk?.id)
          )
          const sidewalkWidth = sidewalkArr.map((sidewalk) => sidewalk?.width)
          const minSidewalkWidth = Math.min(...sidewalkWidth)
          // Set Usable sidewalk  width
          if (minSidewalkWidth < 6) {
            store.dispatch(
              setPedestrianInputs({
                field: USABLE_SIDEWALK_WIDTH,
                value: USABLE_SIDEWALK_WIDTH_VALUES[3]
              })
            )
          } else if (minSidewalkWidth >= 6 && minSidewalkWidth <= 7) {
            store.dispatch(
              setPedestrianInputs({
                field: USABLE_SIDEWALK_WIDTH,
                value: USABLE_SIDEWALK_WIDTH_VALUES[2]
              })
            )
          } else if (minSidewalkWidth >= 8 && minSidewalkWidth <= 9) {
            store.dispatch(
              setPedestrianInputs({
                field: USABLE_SIDEWALK_WIDTH,
                value: USABLE_SIDEWALK_WIDTH_VALUES[1]
              })
            )
          } else if (minSidewalkWidth >= 10) {
            store.dispatch(
              setPedestrianInputs({
                field: USABLE_SIDEWALK_WIDTH,
                value: USABLE_SIDEWALK_WIDTH_VALUES[0]
              })
            )
          } else {
            store.dispatch(
              setPedestrianInputs({
                field: USABLE_SIDEWALK_WIDTH,
                value: ''
              })
            )
          }

          const sidewalkIsAttached = getFirstAndLastSidewalksAreAttached(segments, sidewalkIndexArr)

          const firstLaneIndex = segments?.findIndex(
            (segment) =>
              segment?.type?.indexOf('lane') !== -1 &&
              segment?.type?.indexOf('parking-lane') === -1
          )
          const firstDriveLaneIndex = segments?.findIndex(
            (segment) => segment?.type === 'drive-lane'
          )
          // Get first sidewalk index
          const firstSidewalkIndex = segments.findIndex(
            (segments) => segments?.type === 'sidewalk'
          )

          // Reverse segments to find last lane id
          const copyOfSegmentsToReverse = [...segments]

          const lastLaneId = copyOfSegmentsToReverse
            .reverse()
            .find(
              (segment) =>
                segment?.type?.indexOf('lane') !== -1 &&
                segment?.type?.indexOf('parking-lane') === -1
            )?.id

          const lastLandeIndex = segments.findIndex(
            (segment) => segment?.id === lastLaneId
          )
          const lastDriveLaneId = copyOfSegmentsToReverse.find(
            (segment) => segment?.type === 'drive-lane'
          )?.id
          const lastDriveLaneIndex = segments?.findIndex(
            (segment) => segment?.id === lastDriveLaneId
          )
          const reverseSidewalkId = copyOfSegmentsToReverse.find(
            (segment) => segment?.type === 'sidewalk'
          )?.id

          const reverseSidewalkIndex = segments.findIndex(
            (segment) => segment?.id === reverseSidewalkId
          )
          const isAttachedSidewalk = sidewalkIsAttached.every(
            (isAttached) => isAttached
          )
          // Both sidewalks detached
          const isSidewalkDetached = sidewalkIsAttached.every(
            (isAttached) => !isAttached
          )

          // If its a detached sidewalk , check for buffer quality
          // if (isSidewalkDetached) {
          //   // Check for buffer quality - width
          //   if (
          //     segments[firstLaneIndex - 1]?.variantString ===
          //       'striped-buffer' ||
          //     segments[lastLandeIndex + 1]?.variantString === 'striped-buffer'
          //   ) {
          //     store.dispatch(
          //       setPedestrianInputs({
          //         field: BUFFER_QUALITY,
          //         value: BUFFER_QUALITY_VALUES[2]
          //       })
          //     )
          //   } else if (
          //     segments[firstLaneIndex - 1]?.variantString === 'big-tree' ||
          //     segments[lastLandeIndex + 1]?.variantString === 'big-tree'
          //   ) {
          //     store.dispatch(
          //       setPedestrianInputs({
          //         field: BUFFER_QUALITY,
          //         value: BUFFER_QUALITY_VALUES[0]
          //       })
          //     )
          //   } else if (
          //     (segments[firstLaneIndex - 1]?.type.includes('parking-lane') ===
          //       true &&
          //       segments[firstLaneIndex - 1]?.variantString?.includes(
          //         'inbound|left'
          //       ) === true) ||
          //     (segments[lastLandeIndex + 1]?.type.includes('parking-lane') ===
          //       true &&
          //       segments[lastLandeIndex + 1]?.variantString?.includes(
          //         'outbound|right'
          //       ) === true)
          //   ) {
          //     store.dispatch(
          //       setPedestrianInputs({
          //         field: BUFFER_QUALITY,
          //         value: BUFFER_QUALITY_VALUES[1]
          //       })
          //     )
          //   } else {
          //     store.dispatch(
          //       setPedestrianInputs({
          //         field: BUFFER_QUALITY,
          //         value: ''
          //       })
          //     )
          //   }
          // }

          // If sidewlak is Detached, then calculate buffer width
          if (isSidewalkDetached) {
            let bufferLeftWidth = 0
            let bufferRightWidth = 0
            segments.forEach((segment, index) => {
              if (index > firstSidewalkIndex && index < firstDriveLaneIndex) {
                bufferLeftWidth += segment?.width
              }
              if (index > lastDriveLaneIndex && index < reverseSidewalkIndex) {
                bufferRightWidth += segment?.width
              }
            })

            if (bufferLeftWidth >= 14 || bufferRightWidth >= 14) {
              store.dispatch(
                setPedestrianInputs({
                  field: BUFFER_WIDTH,
                  value: BUFFER_WIDTH_VALUES[0]
                })
              )
            } else if (bufferLeftWidth <= 14 || bufferRightWidth <= 14) {
              store.dispatch(
                setPedestrianInputs({
                  field: BUFFER_WIDTH,
                  value: BUFFER_WIDTH_VALUES[1]
                })
              )
            } else {
              store.dispatch(
                setPedestrianInputs({
                  field: BUFFER_WIDTH,
                  value: ''
                })
              )
            }
          }

          if (isAttachedSidewalk) {
            store.dispatch(
              setPedestrianInputs({
                field: key,
                value: PEDESTRIAN_FACILITY_TYPE_VALUES[1]
              })
            )
          } else if (isSidewalkDetached) {
            store.dispatch(
              setPedestrianInputs({
                field: key,
                value: PEDESTRIAN_FACILITY_TYPE_VALUES[0]
              })
            )
          } else {
            store.dispatch(
              setPedestrianInputs({
                field: key,
                value: ''
              })
            )
          }
        } else {
          // Since no sidewalk , dispatch pedestrian input to no sidewalk
          store.dispatch(
            setPedestrianInputs({
              field: key,
              value: PEDESTRIAN_FACILITY_TYPE_VALUES[2]
            })
          )
        }
        break
      case COMFORT_ZONE_WIDTH:
        // Check if there is a sidewalk , if so get the width
        // If no sidewalk , reset the option for comfort zone width
        if (segments.some((segment) => segment?.type === 'sidewalk') === true) {
          // Filter all sidewalk segments
          const sidewalkArr = segments.filter(
            (segment) => segment?.type === 'sidewalk'
          )
          // Check if width of both sidewalks is less/ greater than 6ft

          const allSidewalksGreaterEqualTo_6 = sidewalkArr.every(
            (segment) => segment?.width >= 6
          )
          const allSidewalksLesserThan_6 = sidewalkArr.every(
            (segment) => segment?.width < 6
          )
          if (allSidewalksGreaterEqualTo_6) {
            store.dispatch(
              setPedestrianInputs({
                field: key,
                value: COMFORT_ZONE_WIDTH_VALUES[0]
              })
            )
          } else if (allSidewalksLesserThan_6) {
            store.dispatch(
              setPedestrianInputs({
                field: key,
                value: COMFORT_ZONE_WIDTH_VALUES[1]
              })
            )
          } else {
            // Reset the field if none of the above conditions are met
            store.dispatch(
              setPedestrianInputs({
                field: key,
                value: ''
              })
            )
          }
        } else {
          // Reset the field, when there is no sidewalk
          store.dispatch(
            setPedestrianInputs({
              field: key,
              value: ''
            })
          )
        }
        break
      case SIDEWALK_ACCESSIBILITY:
        break
      case LIGHTING:
        // Check if there is a lamp
        // If no sidewalk , do not select any option for comfort zone width
        // if (
        //   segments.some((segment) => segment?.type.includes('lamp')) === true
        // ) {
        //   // Filter all lamp segments
        //   const lampArr = segments.filter((segment) =>
        //     segment?.type.includes('lamp')
        //   )

        //   // Get the segment next to lamp, based on lamp orientation
        //   const segmentIndexsAdjacentLamp = lampArr.map((segment) => {
        //     if (
        //       segment &&
        //       segment?.variant &&
        //       segment?.variant['lamp-orientation'] === 'right'
        //     ) {
        //       return segments.findIndex((seg) => seg?.id === segment?.id) + 1
        //     } else if (
        //       segment &&
        //       segment?.variant &&
        //       segment?.variant['lamp-orientation'] === 'left'
        //     ) {
        //       return segments.findIndex((seg) => seg?.id === segment?.id) - 1
        //     }
        //   })

        //   // Get the segmetns next to lamp
        //   const segmentsAdjacentLamps = segmentIndexsAdjacentLamp.map(
        //     (index) => {
        //       return segments.find(
        //         (segment, segmentIndex) => index === segmentIndex
        //       )
        //     }
        //   )
        //   // Check if all adjacent segments are lanes
        //   const allSegmentsLanesorDividersorParking =
        //     segmentsAdjacentLamps.every(
        //       (segment) =>
        //         segment?.type.includes('drive-lane') ||
        //         segment?.type.includes('bike-lane') ||
        //         segment?.type.includes('divider') ||
        //         segment?.type.includes('parking-lane')
        //     )

        //   // Check if all adjacent segments are not lanes
        //   const allSegmentsSidewalk = segmentsAdjacentLamps.every((segment) =>
        //     segment?.type.includes('sidewalk')
        //   )

        //   if (allSegmentsLanesorDividersorParking) {
        //     store.dispatch(
        //       setPedestrianInputs({
        //         field: key,
        //         value: LIGHTING_VALUES[1]
        //       })
        //     )
        //   } else if (
        //     allSegmentsSidewalk ||
        //     !allSegmentsLanesorDividersorParking
        //   ) {
        //     store.dispatch(
        //       setPedestrianInputs({
        //         field: key,
        //         value: LIGHTING_VALUES[0]
        //       })
        //     )
        //   } else {
        //     store.dispatch(
        //       setPedestrianInputs({
        //         field: key,
        //         value: ''
        //       })
        //     )
        //   }
        // } else {
        //   // No Lighting
        //   store.dispatch(
        //     setPedestrianInputs({
        //       field: key,
        //       value: LIGHTING_VALUES[2]
        //     })
        //   )
        //   removeTransitStopAmenitiesInput(2)
        // }
        break
      case CROSSING_IMPROVEMENTS:
        // Check if the street has a median
        // if (
        //   segments.some(
        //     (segment) =>
        //       segment?.type === 'divider' && segment?.variantString === 'median'
        //   )
        // ) {
        //   // Only select crossing imporovement value , when its alreadt not selected
        //   !crossing_improvements.includes(CROSSING_IMPROVEMENTS_VALUES[1]) &&
        //     store.dispatch(
        //       setPedestrianInputs({
        //         field: key,
        //         value: CROSSING_IMPROVEMENTS_VALUES[1]
        //       })
        //     )
        // } else {
        //   // Clean median selection
        //   crossing_improvements.includes(CROSSING_IMPROVEMENTS_VALUES[1]) &&
        //     store.dispatch(
        //       setPedestrianInputs({
        //         field: key,
        //         value: CROSSING_IMPROVEMENTS_VALUES[1]
        //       })
        //     )
        // }
        break

      default:
    }
  }
}
